module.exports = __webpack_public_path__ + "static/media/image9.02dde475.JPG";